import { styled, Theme } from "@mui/material/styles";

export const toolbarButtonSx = (theme: Theme) => ({
  height: 44,
  "& .MuiButton-startIcon > *:nth-of-type(1)": {
    fontSize: "20px !important",
    marginBottom: 0
  },
  [theme.breakpoints.up("sm")]: {
    height: 40
  },
  [theme.breakpoints.up(960)]: {
    height: 38
  }
});

export const ToolbarValidationAction = styled("div")(({ theme }) => ({
  display: "flex",
  marginLeft: theme.spacing(0.5)
}));
